export const MFA_LABELS = {
  Email: 'Send to email address',
  SMS: 'Send to mobile number',
};
